module.exports = __webpack_public_path__ + "img/marisa kirisame lunar war enchanter_lw.3e62518c.png";